if (!window.webstore) window.webstore = {}
if (!frappe.boot) frappe.boot = {}
